var dataTemplate = {
    eChook: {
        binary: {
            variableThrottle: {
                name: "Throttle Type",
                op1: "Variable",
                op2: "On/Off",
                value: null,
                old: null,
                hidden: 0,
                changed: 0,
            },
            throttleOut: {
                name: "Throttle Output (PWM)",
                op1: "On",
                op2: "Off",
                value: null,
                old: null,
                hidden: 0,
                changed: 0,
            },
            throttleRamp: {
                name: "Throttle Ramp",
                op1: "On",
                op2: "Off",
                value: null,
                old: null,
                hidden: 0,
                changed: 0,
            },
            linearTempSensor: {
                name: "Temp Sensor Type",
                op1: "Linear",
                op2: "Thermistor",
                value: null,
                old: null,
                hidden: 1,
                changed: 0,
            },
        },
        bluetoothName: {
            calibratable: 1,
            value: null,
            old: null,
            hidden: 1,
            changed: 0,
        },
        transmitInterval: {
            title: "Data Transmit Interval",
            precision: 0,
            units: "ms",
            identifier: null,
            hidden: 1,
            calibratable: 1,
            calibration: {
                interval: {
                    name: "Interval",
                    units: "ms",
                    value: null,
                    floatIndex: 0,
                    changed: 0,
                    old: null,
                },
            },
        },
        referenceVoltageStatic: {
            title: "Fallback Rail Voltage",
            precision: 2,
            units: "V",
            value: null,
            identifier: null,
            calibratable: 1,
            hidden: 1,
            calibration: {
                voltage: {
                    name: "Fallback Rail Voltage",
                    precision: 2,
                    unit: "Volts",
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 3,
                },
            },
            helper: "Only used by the Arduino Nano Every, and only when a live rail measurement fails its sanity check. The board falls back to this stored value instead of a measured one. Leave it at 5.00 unless you know this board's rail sits elsewhere.",
        },
        referenceVoltage: {
            title: "Reference Voltage",
            precision: 2,
            units: "V",
            value: null,
            identifier: "V",
            calibratable: 1,
            calibration: {
                voltage: {
                    name: "Internal Reference",
                    precision: 2,
                    unit: "Volts",
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 16,
                },
            },
            helper: "Both the Nano and the Nano Every measure the +5V rail against a stable ~1.1v internal reference. Tweak that internal reference value until the reading matches the multimeter measured voltage on the +5V test point on the board.",
        },
        speed: {
            title: "Speed",
            precision: 2,
            units: "m/s",
            value: null,
            identifier: "s",
            calibratable: 1,
            calibration: {
                magnets: {
                    name: "Magnets",
                    precision: 0,
                    value: null,
                    floatIndex: 1,
                    changed: 0,
                    old: null,
                },
                circumference: {
                    name: "Circumference",
                    unit: "meters",
                    precision: 2,
                    value: null,
                    floatIndex: 15,
                    changed: 0,
                    old: null,
                },
            },
        },
        rpm: {
            title: "Motor RPM",
            precision: 0,
            units: "RPM",
            value: null,
            identifier: "m",
            calibratable: 1,
            calibration: {
                magnets: {
                    name: "Magnets",
                    value: null,
                    floatIndex: 2,
                    changed: 0,
                    old: null,
                },
            },
        },
        current: {
            title: "Current",
            precision: 2,
            units: "A",
            value: null,
            identifier: "i",
            calibratable: 1,
            calibration: {
                multiplier: {
                    name: "Scaling Factor",
                    precision: 2,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 6,
                },
            },
        },
        voltage: {
            title: "Voltage (total)",
            precision: 2,
            units: "V",
            value: null,
            identifier: "v",
            calibratable: 1,
            calibration: {
                multiplier: {
                    name: "Scaling Factor",
                    precision: 2,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 4,
                },
            },
        },
        voltageLower: {
            title: "Volatge (lower)",
            precision: 2,
            units: "V",
            value: null,
            identifier: "w",
            calibratable: 1,
            calibration: {
                multiplier: {
                    name: "Scaling Factor",
                    precision: 2,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 5,
                },
            },
            
        },
        throttleVoltage: {
            title: "Throttle Input Voltage",
            precision: 2,
            units: "V",
            value: null,
            identifier: "T",
            calibratable: 0,
            calibration: {
                multiplier: {
                    value: null, // Not used, but present to keep the object iterable in the template
                    precision: 1,
                    changed: 0,
                    old: null,
                    floatIndex: null,
                },
            },
            helper: "This is the voltage seen by the Arduino on the Throttle Input",
        },
        throttleInput: {
            title: "Throttle Input Percentage",
            precision: 2,
            units: "%",
            value: null,
            identifier: "t",
            calibratable: 1,
            calibration: {
                lowThreshold: {
                    name: "Low Threshold",
                    unit: "Volts",
                    value: null,
                    precision: 2,
                    changed: 0,
                    old: null,
                    floatIndex: 13,
                },
                highThreshold: {
                    name: "High Threshold",
                    unit: "Volts",
                    value: null,
                    precision: 2,
                    changed: 0,
                    old: null,
                    floatIndex: 14,
                },
            },
            helper: "This is the interpreted throttle percentage from the input voltage. For variable throttle, the lower and upper voltages define 0% and 100%, with voltages between being interpreted linearly. For pushbutton throttles, a voltage above the upper voltage is 100%, and below the lower voltages is 0%",
        },
        throttleActual: {
            title: "Throttle Actual",
            precision: 1,
            units: "%",
            value: null,
            identifier: "d",
            calibratable: 0,
            calibration: {
                multiplier: {
                    value: null, // Not used, but present to keep the object iterable in the template
                    precision: 1,
                    changed: 0,
                    old: null,
                    floatIndex: null,
                },
            },
            helper:"This is the output PWM percentage for the motor driver",
        },
        temp3: {
            title: "Temperature eChook",
            precision: 0,
            units: "°c",
            value: null,
            identifier: "c",
            calibratable: 0,
            calibration: {
                placeholder: {
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: null, // no calibration
                },
            },
            helper: "Internal Temperature of the Arduino from the on-chip sensor",
        },
        temp1: {
            title: "Temperature 1",
            precision: 0,
            units: "°c",
            value: null,
            identifier: "a",
            calibratable: 1,
            calibration: {
                A: {
                    name: "Cal A",
                    precision: 7,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 7,
                },
                B: {
                    name: "Cal B",
                    precision: 7,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 8,
                },
                C: {
                    name: "Cal C",
                    precision: 7,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 9,
                },
            },
        },
        temp2: {
            title: "Temperature 2",
            precision: 0,
            units: "°c",
            value: null,
            identifier: "b",
            calibratable: 1,
            calibration: {
                A: {
                    name: "Cal A",
                    precision: 7,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 10,
                },
                B: {
                    name: "Cal B",
                    precision: 7,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 11,
                },
                C: {
                    name: "Cal C",
                    precision: 7,
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: 12,
                },
            },
        },

        launchMode: {
            title: "Launch Mode Button",
            precision: 0,
            units: null,
            value: 0,
            identifier: "L",
            calibratable: 0,
            calibration: {
                placeholder: {
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: null, // no calibration
                },
            },
        },
        cycleView: {
            title: "Next Screen Button",
            precision: 0,
            units: null,
            value: 0,
            identifier: "C",
            calibratable: 0,
            calibration: {
                placeholder: {
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: null, // no calibration
                },
            },
        },
        gearRatio: {
            title: "Gear Ratio",
            precision: 2,
            units: null,
            value: null,
            identifier: "r",
            calibratable: 0,
            calibration: {
                placeholder: {
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: null, // no calibration
                },
            },
        },
        brakePressed: {
            title: "Brake Switch",
            precision: 0,
            units: null,
            value: 0,
            identifier: "B",
            calibratable: 0,
            calibration: {
                inverted: {
                    name: "Inverted",
                    value: null,
                    changed: 0,
                    old: null,
                    floatIndex: null, // no calibration
                },
            },
        },
    },
}

export { dataTemplate }